var _defs, _g, _defs2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _g6, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSatellite = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 244,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 244 244",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.04.337h13.964V14.07H.04z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 122,
    r: 122,
    fill: "#444",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 63,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 112,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 171,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 215,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 72.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 22.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 186.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 221.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 143.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 72.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 58.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 116.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 143.5,
    r: 2.5,
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(179 95)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(159 175)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(59 170)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(89 31)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5358D",
    d: "M140.5 129L125 144l7.75 7.5 15.419-15zM107.5 97L92 112l7.75 7.5 15.419-15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M111.807 148.188a2.048 2.048 0 0 1-1.441-.587 1.978 1.978 0 0 1 .001-2.83l16.055-15.776-5.091-5.01a1.978 1.978 0 0 1 .001-2.833 2.059 2.059 0 0 1 2.88.001l6.531 6.427c.796.782.796 2.05 0 2.831l-17.496 17.191a2.05 2.05 0 0 1-1.44.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M108.157 151.777a2.052 2.052 0 0 1-1.44-.586L92.513 137.23a1.98 1.98 0 0 1 0-2.833l21.14-20.784a2.064 2.064 0 0 1 2.882 0l4.009 3.937a1.98 1.98 0 0 1 0 2.832 2.062 2.062 0 0 1-2.88.002l-2.568-2.524-18.262 17.953 12.763 12.547a1.98 1.98 0 0 1 0 2.832c-.398.391-.919.586-1.44.586M127.146 128.877a2.052 2.052 0 0 1-1.44-.586 1.98 1.98 0 0 1 0-2.832l16.622-16.339a2.062 2.062 0 0 1 2.88 0 1.979 1.979 0 0 1 0 2.833l-16.62 16.338c-.399.39-.92.586-1.442.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M117.255 119.151a2.052 2.052 0 0 1-1.44-.586 1.98 1.98 0 0 1 0-2.832l20.485-20.14a2.06 2.06 0 0 1 2.88.002l9.892 9.727c.796.782.796 2.05 0 2.83a2.059 2.059 0 0 1-2.88 0l-8.452-8.31-19.044 18.723c-.398.39-.919.586-1.44.586"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.655 90.748)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M11.968 14.069a2.048 2.048 0 0 1-1.441-.587L.635 3.755A1.978 1.978 0 0 1 .636.924a2.06 2.06 0 0 1 2.881.001l9.892 9.727c.794.78.794 2.049-.001 2.831a2.05 2.05 0 0 1-1.44.586",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M124.85 119.173a2.054 2.054 0 0 1-1.442-.585 1.98 1.98 0 0 1 0-2.833l12.787-12.572a2.064 2.064 0 0 1 2.882 0 1.98 1.98 0 0 1 0 2.832l-12.787 12.573c-.398.39-.919.585-1.44.585M102.065 137.831a2.052 2.052 0 0 1-1.442-.586 1.98 1.98 0 0 1 0-2.832l13.192-12.966a2.064 2.064 0 0 1 2.882 0 1.98 1.98 0 0 1 0 2.832l-13.191 12.966c-.4.391-.92.586-1.441.586M109.584 115.865c-.52 0-1.042-.195-1.44-.585l-1.557-1.528a1.98 1.98 0 0 1-.002-2.833 2.068 2.068 0 0 1 2.882-.002l1.557 1.529a1.98 1.98 0 0 1 .002 2.832c-.4.39-.92.587-1.442.587"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M94.918 112.075l5.248 5.158 12.845-12.63-5.245-5.157-12.848 12.629zm5.248 9.991a2.054 2.054 0 0 1-1.441-.585l-8.13-7.99a1.99 1.99 0 0 1-.595-1.416c0-.53.214-1.04.596-1.417l15.728-15.46a2.064 2.064 0 0 1 2.882 0l8.126 7.99c.382.375.597.885.597 1.415 0 .532-.215 1.04-.597 1.417l-15.725 15.46c-.398.391-.919.586-1.44.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M104.74 111.102a2.052 2.052 0 0 1-1.44-.585l-4.838-4.757a1.979 1.979 0 0 1 0-2.832 2.062 2.062 0 0 1 2.88 0l4.84 4.756a1.98 1.98 0 0 1 0 2.833c-.399.39-.92.585-1.442.585M127.063 143.671l5.244 5.157 12.848-12.627-5.245-5.157-12.847 12.627zm5.244 9.992c-.54 0-1.058-.21-1.44-.586l-8.126-7.99a1.98 1.98 0 0 1 0-2.832l15.728-15.46a2.062 2.062 0 0 1 2.881 0l8.126 7.99a1.98 1.98 0 0 1 0 2.832l-15.728 15.46a2.06 2.06 0 0 1-1.44.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M136.883 142.7a2.05 2.05 0 0 1-1.44-.586l-6.396-6.284a1.978 1.978 0 0 1-.001-2.831 2.06 2.06 0 0 1 2.881-.001l6.396 6.284c.795.78.795 2.049 0 2.831-.398.392-.919.587-1.44.587M125.022 111.519c-.784 0-1.53-.447-1.865-1.197l-3.617-8.076a1.989 1.989 0 0 1 1.044-2.639c1.03-.447 2.232.014 2.684 1.025l3.616 8.076a1.988 1.988 0 0 1-1.043 2.64c-.267.115-.546.17-.82.17M120.939 94.124a2.679 2.679 0 0 1 0 3.835 2.794 2.794 0 0 1-3.902 0 2.68 2.68 0 0 1 0-3.835 2.794 2.794 0 0 1 3.902 0M143.125 124.796c-.274 0-.553-.055-.819-.17l-8.216-3.554a1.987 1.987 0 0 1-1.045-2.638c.452-1.013 1.656-1.473 2.685-1.027l8.216 3.554a1.986 1.986 0 0 1 1.044 2.638 2.036 2.036 0 0 1-1.865 1.197M150.567 123.252a2.787 2.787 0 0 0-3.9 0 2.675 2.675 0 0 0 0 3.832 2.787 2.787 0 0 0 3.9 0 2.675 2.675 0 0 0 0-3.832"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 244,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 244 244",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.04.337h13.964V14.07H.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: fill,
    fillRule: "evenodd"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 122,
    r: 122,
    fill: "#444",
    opacity: 0.02
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 63,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 112,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 171,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 215,
    r: 4,
    stroke: "#DEDFE3",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 72.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.5,
    cy: 22.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 186.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.5,
    cy: 221.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 143.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 72.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 58.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 116.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 143.5,
    r: 2.5,
    fill: "#DEDFE3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(179 95)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(159 175)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(59 170)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#DEDFE3",
    transform: "translate(89 31)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    x: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    y: 3,
    rx: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5358D",
    d: "M140.5 129L125 144l7.75 7.5 15.419-15zM107.5 97L92 112l7.75 7.5 15.419-15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M111.807 148.188a2.048 2.048 0 0 1-1.441-.587 1.978 1.978 0 0 1 .001-2.83l16.055-15.776-5.091-5.01a1.978 1.978 0 0 1 .001-2.833 2.059 2.059 0 0 1 2.88.001l6.531 6.427c.796.782.796 2.05 0 2.831l-17.496 17.191a2.05 2.05 0 0 1-1.44.586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M108.157 151.777a2.052 2.052 0 0 1-1.44-.586L92.513 137.23a1.98 1.98 0 0 1 0-2.833l21.14-20.784a2.064 2.064 0 0 1 2.882 0l4.009 3.937a1.98 1.98 0 0 1 0 2.832 2.062 2.062 0 0 1-2.88.002l-2.568-2.524-18.262 17.953 12.763 12.547a1.98 1.98 0 0 1 0 2.832c-.398.391-.919.586-1.44.586M127.146 128.877a2.052 2.052 0 0 1-1.44-.586 1.98 1.98 0 0 1 0-2.832l16.622-16.339a2.062 2.062 0 0 1 2.88 0 1.979 1.979 0 0 1 0 2.833l-16.62 16.338c-.399.39-.92.586-1.442.586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M117.255 119.151a2.052 2.052 0 0 1-1.44-.586 1.98 1.98 0 0 1 0-2.832l20.485-20.14a2.06 2.06 0 0 1 2.88.002l9.892 9.727c.796.782.796 2.05 0 2.83a2.059 2.059 0 0 1-2.88 0l-8.452-8.31-19.044 18.723c-.398.39-.919.586-1.44.586"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.655 90.748)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M11.968 14.069a2.048 2.048 0 0 1-1.441-.587L.635 3.755A1.978 1.978 0 0 1 .636.924a2.06 2.06 0 0 1 2.881.001l9.892 9.727c.794.78.794 2.049-.001 2.831a2.05 2.05 0 0 1-1.44.586",
    mask: "url(#b)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M124.85 119.173a2.054 2.054 0 0 1-1.442-.585 1.98 1.98 0 0 1 0-2.833l12.787-12.572a2.064 2.064 0 0 1 2.882 0 1.98 1.98 0 0 1 0 2.832l-12.787 12.573c-.398.39-.919.585-1.44.585M102.065 137.831a2.052 2.052 0 0 1-1.442-.586 1.98 1.98 0 0 1 0-2.832l13.192-12.966a2.064 2.064 0 0 1 2.882 0 1.98 1.98 0 0 1 0 2.832l-13.191 12.966c-.4.391-.92.586-1.441.586M109.584 115.865c-.52 0-1.042-.195-1.44-.585l-1.557-1.528a1.98 1.98 0 0 1-.002-2.833 2.068 2.068 0 0 1 2.882-.002l1.557 1.529a1.98 1.98 0 0 1 .002 2.832c-.4.39-.92.587-1.442.587"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M94.918 112.075l5.248 5.158 12.845-12.63-5.245-5.157-12.848 12.629zm5.248 9.991a2.054 2.054 0 0 1-1.441-.585l-8.13-7.99a1.99 1.99 0 0 1-.595-1.416c0-.53.214-1.04.596-1.417l15.728-15.46a2.064 2.064 0 0 1 2.882 0l8.126 7.99c.382.375.597.885.597 1.415 0 .532-.215 1.04-.597 1.417l-15.725 15.46c-.398.391-.919.586-1.44.586z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M104.74 111.102a2.052 2.052 0 0 1-1.44-.585l-4.838-4.757a1.979 1.979 0 0 1 0-2.832 2.062 2.062 0 0 1 2.88 0l4.84 4.756a1.98 1.98 0 0 1 0 2.833c-.399.39-.92.585-1.442.585M127.063 143.671l5.244 5.157 12.848-12.627-5.245-5.157-12.847 12.627zm5.244 9.992c-.54 0-1.058-.21-1.44-.586l-8.126-7.99a1.98 1.98 0 0 1 0-2.832l15.728-15.46a2.062 2.062 0 0 1 2.881 0l8.126 7.99a1.98 1.98 0 0 1 0 2.832l-15.728 15.46a2.06 2.06 0 0 1-1.44.586z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#44444D",
    d: "M136.883 142.7a2.05 2.05 0 0 1-1.44-.586l-6.396-6.284a1.978 1.978 0 0 1-.001-2.831 2.06 2.06 0 0 1 2.881-.001l6.396 6.284c.795.78.795 2.049 0 2.831-.398.392-.919.587-1.44.587M125.022 111.519c-.784 0-1.53-.447-1.865-1.197l-3.617-8.076a1.989 1.989 0 0 1 1.044-2.639c1.03-.447 2.232.014 2.684 1.025l3.616 8.076a1.988 1.988 0 0 1-1.043 2.64c-.267.115-.546.17-.82.17M120.939 94.124a2.679 2.679 0 0 1 0 3.835 2.794 2.794 0 0 1-3.902 0 2.68 2.68 0 0 1 0-3.835 2.794 2.794 0 0 1 3.902 0M143.125 124.796c-.274 0-.553-.055-.819-.17l-8.216-3.554a1.987 1.987 0 0 1-1.045-2.638c.452-1.013 1.656-1.473 2.685-1.027l8.216 3.554a1.986 1.986 0 0 1 1.044 2.638 2.036 2.036 0 0 1-1.865 1.197M150.567 123.252a2.787 2.787 0 0 0-3.9 0 2.675 2.675 0 0 0 0 3.832 2.787 2.787 0 0 0 3.9 0 2.675 2.675 0 0 0 0-3.832"
  }))));
});
export default SvgSatellite;
export const raw = __webpack_public_path__ + "static/media/satellite.4aae00f8e73c9712104847e78f8418f8.svg";